import axios from 'axios';
import { toast } from 'react-toastify';
import style from './Login.module.css';
import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { Oval } from 'react-loader-spinner';
import { userLogin } from '../../actions/user.action';
import { useDispatch, useSelector } from 'react-redux';
import { ValidateEmail } from '../../utils/ValidateEmail';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [localLoading, setLocalLoading] = useState(false);
  const dispatch = useDispatch();
  const loginstate = useSelector((state) => state.userLoginReducer);
  const { loading } = loginstate;

  const submitHandler = async (e) => {
    e.preventDefault();
    const user = { email: email, pass: password };
    if (email && password) {
      if (ValidateEmail(email)) {
        try {
          setLocalLoading(true);
          const res = await axios.post(`/user/login`, user, {
            headers: { 'Access-Control-Allow-Origin': '*' },
            withCredentials: true,
          });

          if (res.data.message === 'Wrong Credentials!') {
            setLocalLoading(false);
            return toast.error('Wrong credentials!');
          } else if (res.data.message === 'verify') {
            setLocalLoading(false);
            return toast.error('Please verify your account by going to mail!');
          }

          if (res.data.user.twoFactor) {
            localStorage.setItem('validate', JSON.stringify(user));
            localStorage.setItem('xyz', res.data.user.qrSecret);
            window.location.href = '/verify';
          } else dispatch(userLogin(user));
        } catch (error) {
          setLocalLoading(false);
          const msg = error?.response?.data?.message;
          if (msg === 'Wrong Credentials!') toast.error('Wrong credentials!');
          else toast.error(msg || 'Something went wrong!');
        }
      }
    } else {
      toast.error('Please fill the credentials!');
    }
  };

  return (
    <div className={style.Login}>
      <p>Login to your account</p>
      <div className={style.section}>
        <p>Email</p>
        <input
          type='email'
          value={email}
          placeholder='hunter@hackerbro.in'
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className={style.section}>
        <p>Password</p>
        <input
          type='password'
          value={password}
          placeholder='Enter your password'
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div className={style.Button} onClick={!loading && !localLoading ? submitHandler : null} style={loading || localLoading ? { pointerEvents: 'none', opacity: 0.7 } : {}}>
        {loading || localLoading ? (
          <Oval
            ariaLabel='loading-indicator'
            height={30}
            width={30}
            strokeWidth={5}
            color='white'
            secondaryColor='purple'
          />
        ) : (
          'Login'
        )}
      </div>
      <div className={style.Bottom}>
        <span>Forgot your password?</span>
        <Link
          to='/forget-password'
          className='link'
          style={{ color: 'rgb(161, 35, 161)' }}
        >
          {' '}
          Reset it here.
        </Link>
      </div>
      <div className={style.Bottom}>
        <span>Are you new?</span>
        <Link
          to='/signup'
          className='link'
          style={{ color: 'rgb(161, 35, 161)' }}
        >
          {' '}
          Sign up.
        </Link>
      </div>
    </div>
  );
};

export default Login;
